import { BytesLike } from '../types';
import { IsBytesLike } from './validators';

export class SignMessageDto {
  @IsBytesLike({
    acceptText: true,
  })
  message: BytesLike;
}
